interface LogoProps {
    className?: string
}

const Logo = (props: LogoProps) => {
    return <img {...props} src="/go-eve-logo.png" alt="GoEve Logo" height={32} />
}

export default Logo
